import { LoadableLazy } from '@confluence/loadable';

export const RtNeutralMessagingSuppressComponentsHocLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RtNeutralMessagingSuppressComponents" */ '../../src/ui/RtNeutralMessagingSuppressComponentsHoc.tsx'
			)
		).RtNeutralMessagingSuppressComponentsHocWithErrorBoundary,
});
